// src/constants/consent.js
//
// Versioned consent text shown to users when they opt into business SMS.
// Whenever you change the wording, BUMP the version string and add the old
// version to the history below. Each user's consent record snapshots the
// exact text + version they agreed to — required for TCPA / 10DLC defense.
//
// The legal audit trail lives in `users/{uid}/consents/{autoId}` (an
// append-only subcollection written by the `recordConsent` Cloud Function).
// `users/{uid}.compliance.*` mirrors the current state for fast reads.

export const SMS_CONSENT_VERSION = 'sms_v1';

export const SMS_CONSENT_TEXT =
  'By verifying, you agree to receive game-day reminders, schedule changes, ' +
  'and urgent alerts from Scrimly via SMS. Message frequency varies. ' +
  'Msg & data rates may apply. Reply STOP to opt out at any time, or HELP for help.';

// Source identifiers for the `source` field on consent records. Add new
// values when you add new opt-in surfaces (e.g. parent onboarding wizard).
export const CONSENT_SOURCES = Object.freeze({
  PROFILE_VERIFY: 'profile_settings_phone_verify',
  PROFILE_REMOVE_PHONE: 'profile_settings_remove_phone',
  NOTIFICATIONS_TOGGLE_ON: 'notifications_master_sms_on',
  NOTIFICATIONS_TOGGLE_OFF: 'notifications_master_sms_off',
  SMS_STOP_REPLY: 'inbound_sms_stop',
  ADMIN_FORCED: 'admin_action',
});

// Old text revisions kept here for traceability when older audit records
// reference earlier versions. NEVER delete entries — only append.
export const SMS_CONSENT_HISTORY = Object.freeze({
  sms_v1: SMS_CONSENT_TEXT,
});
